import styled from 'styled-components';

export const VinWrapper = styled.span`
  &&, input {
    font-family    : 'Roboto Mono', monospace;
    text-transform : uppercase;
  }
`;
